/* eslint-disable react/require-default-props */
/* eslint-disable no-unused-vars */
/* eslint-disable consistent-return */

import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';

import { selectCurrentSalonCurrency, selectCurrentSalonId } from 'selectors/currentSalon.selectors';
import alwaysNoop from 'utils/functions/nullary/alwaysNoop.util';

import ReportTableV2 from 'reports/Common/ReportTableV2';
import { generateRetailPerformanceTable } from 'reports/utils';

const SalonPerformanceTable = (props) => (
  <div className="performance p5">
    <div id="retail-performance">
      <div className="retail-btn-container">
        <NavLink
          to={`/salon/${props.salonId}/stocks/usedSoldOverDateRange`}
          onClick={alwaysNoop}
          className="btn btn-violet btn-report in-retail-tbl"
        >
          View more stock reports
        </NavLink>
        <ReportTableV2
          data={generateRetailPerformanceTable(
            props.revenueData,
            props.salesReport.stylist_group.filter((s) => s.products_sold_count !== 0),
            props.uniqueClientsReport,
            props.salesReport.visits,
            props.currency,
          )}
          title="Retail Performance"
          startDate={props.startDate}
          endDate={props.endDate}
        />
      </div>
    </div>
  </div>
);

const mapStateToProps = (state) => ({
  currency: selectCurrentSalonCurrency(state),
  salonId: selectCurrentSalonId(state),
});

const SalonPerformanceTableHoc = connect(mapStateToProps)(SalonPerformanceTable);

export default SalonPerformanceTableHoc;
